import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
import { Fragment } from 'react';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import { BaseButton, colors, IconButton, InverseButton, PrimaryButton, ProgressBar
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
} from '@crehana/ui';
import cn from 'classnames';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';
import { REMAINING_SECONDS_TO_SKIP } from "../constants";
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { useTranslation } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SkipButton = function SkipButton(_ref) {
  var nextVideoTitle = _ref.nextVideoTitle;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    visibleSkip = _usePlaybackContext.visibleSkip,
    remainingSeconds = _usePlaybackContext.remainingSeconds,
    onSkip = _usePlaybackContext.onSkip,
    onSkipDismiss = _usePlaybackContext.onSkipDismiss;
  var _useUIContext = useUIContext(),
    autoplayNext = _useUIContext.autoplayNext,
    visibleUi = _useUIContext.visibleUi;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (playerSize.matches.md) {
    return /*#__PURE__*/_jsxs(_StyledDiv, {
      className: cn('cp-skip-desktop absolute flex flex-col z-5', visibleSkip ? 'cui-is-visible' : 'cui-is-hidden'),
      $_css: visibleUi ? 'transform: translateY(-68px);' : '',
      children: [autoplayNext && /*#__PURE__*/_jsx(ProgressBar
      // @ts-expect-error ('data-testid' does not exist in type HTMLAttributes<HTMLDivElement>)
      , {
        htmlProps: {
          'data-testid': 'skip-progress-bar'
        },
        barClassName: "bg-secondary-light",
        backgroundClassName: "bg-gray-dark-56",
        progress: remainingSeconds >= REMAINING_SECONDS_TO_SKIP ? 100 : Math.ceil(remainingSeconds / REMAINING_SECONDS_TO_SKIP * 100),
        size: "s"
      }), /*#__PURE__*/_jsxs("div", {
        className: "px-12 py-12 flex flex-col items-end bg-base-main-80",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "w-full flex items-center justify-between mb-4",
          children: [/*#__PURE__*/_jsx("span", {
            className: "font-label text-gray-dark",
            children: t('NEXT_LECTURE')
          }), /*#__PURE__*/_jsx(IconButton, {
            customIcon: CloseSmall,
            customColor: colors.baseLighter,
            xs: true,
            onClick: onSkipDismiss,
            "aria-label": t('CLOSE')
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "font-subtitle4 text-white w-full mb-16",
          children: nextVideoTitle
        }), /*#__PURE__*/_jsx(InverseButton, {
          isWhite: true,
          isDark: true,
          size: "xs",
          label: t('SKIP_VIDEO'),
          onClick: onSkip
        })]
      })]
    });
  }
  var mobileSkipCss = /*#__PURE__*/css(["\n    bottom: 8px;\n    right: 8px;\n  "]);
  var mobileLandscapeSkipCss = /*#__PURE__*/css(["\n    bottom: 16px;\n    right: 24px;\n  "]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: cn('cp-skip-gradient-wrapper absolute inset-0 z-1', visibleSkip && !visibleUi ? 'cui-is-visible' : 'cui-is-hidden'),
      children: /*#__PURE__*/_jsx("div", {
        className: "relative w-full h-full overflow-hidden",
        children: /*#__PURE__*/_jsx(_StyledDiv2, {
          className: "cp-skip-gradient absolute bottom-0 right-0 opacity-50 z-1",
          $_css2: playerSize.matches.xs ? '-257px' : '-400px'
        })
      })
    }), /*#__PURE__*/_jsx(_StyledDiv3, {
      className: "cp-skip-mobile absolute z-5 ".concat(visibleSkip && !visibleUi ? 'cui-is-visible' : 'cui-is-hidden'),
      $_css3: playerSize.matches.xs ? mobileLandscapeSkipCss : mobileSkipCss,
      children: autoplayNext ? /*#__PURE__*/_jsxs(BaseButton, {
        onClick: onSkip,
        className: cn('px-16 bg-purple-lighter rounded-5 overflow-hidden relative', playerSize.matches.sm ? 'h-40' : 'h-32'),
        children: [/*#__PURE__*/_jsx(_StyledDiv4, {
          "data-testid": "skip-button-mobile-progress",
          className: "absolute top-0 left-0 h-full bg-purple-light",
          $_css4: remainingSeconds >= REMAINING_SECONDS_TO_SKIP ? 0 : Math.ceil((REMAINING_SECONDS_TO_SKIP - remainingSeconds) / REMAINING_SECONDS_TO_SKIP * 100)
        }), /*#__PURE__*/_jsx("span", {
          className: "font-link text-white z-1",
          children: t('SKIP_VIDEO')
        })]
      }) : /*#__PURE__*/_jsx(PrimaryButton, {
        label: t('SKIP_VIDEO'),
        onClick: onSkip,
        size: playerSize.matches.sm ? 's' : 'xs',
        isDark: true
      })
    })]
  });
};
export default SkipButton;
var _StyledDiv = /*#__PURE__*/_styled("div")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n          right: 8px;\n          bottom: 24px;\n          width: 30%;\n          max-width: 320px;\n          ", "\n        "])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div")(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteral(["\n              width: 940px;\n              height: 159px;\n              bottom: -49px;\n              right: ", ";\n              background-image: radial-gradient(\n                37.5% 37.5% at 50% 50%,\n                ", " 0%,\n                rgba(24, 27, 50, 0) 100%\n              );\n            "])), function (p) {
  return p.$_css2;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.base.main;
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div")(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv4 = /*#__PURE__*/_styled4("div").withConfig({
  componentId: "sc-1c34byq-0"
})(["\n                width: ", "%;\n                transition: ", ";\n              "], function (p) {
  return p.$_css4;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition('width');
});